// extracted by mini-css-extract-plugin
export default {"wrapper":"TutorLessonMedia_wrapper__cEuMk","hostOnly":"TutorLessonMedia_hostOnly__xb3Gj","peer":"TutorLessonMedia_peer__AnMVt","host":"TutorLessonMedia_host__rPIRz"};